export const getOTPErrorMessage = error => {
  let message = ''
  switch (error?.errors) {
    case 'Too many requests':
      message = 'Please wait 2 minutes before requesting another verification code.'
      break
    case 'Max send attempts reached':
      message =
        'There is a temporary block due to too many OTP requests. Please wait 10 minutes before requesting another verification code.'
      break
    default:
      message = error?.message
      break
  }
  return message
}
